import React from 'react';

export default function LoadingState() {
    return (
        <div style={{ textAlign: 'center', padding: '40px' }}>
            <p>Loading tasks...</p>
        </div>
    );
}

